<div class="container mt-4">
  <h1 class="h1 title-blue-h1-cap mt-2">Mis QRs</h1>
  <hr />

  <mat-tab-group>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="example-tab-icon">qr_code</mat-icon>
        &nbsp;&nbsp; Mis sesiones
      </ng-template>
      <app-my-qr-filters></app-my-qr-filters>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="example-tab-icon">share</mat-icon>
        &nbsp;&nbsp; Compartidos conmigo
      </ng-template>
      <!--<app-share-qrs-catalog></app-share-qrs-catalog>-->
      <app-modal-share-qr-filters></app-modal-share-qr-filters>
    </mat-tab>
    <mat-tab *ngIf="canSeeNationalQrs">
      <ng-template mat-tab-label>
        <mat-icon>public</mat-icon>
        &nbsp;&nbsp; QRs Nacionales
      </ng-template>
      <app-my-qr-filters-global></app-my-qr-filters-global>
    </mat-tab>
  </mat-tab-group>
</div>
